"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigation = void 0;

var _react = require("react");

var _history = require("history");

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _curry = _interopRequireDefault(require("ramda/src/curry"));

var _equals = _interopRequireDefault(require("ramda/src/equals"));

var _partial = _interopRequireDefault(require("ramda/src/partial"));

var _utils = require("../../utils");
/* eslint-disable react-hooks/exhaustive-deps */


var SLASH_URL_PATTERN = /^\/|\/$/g;
var toPath = (0, _partial.default)(_utils.addPrefix, '/');

var pathToStep = function pathToStep(pathname) {
  return String(pathname).replace(SLASH_URL_PATTERN, '');
};

var activeByPath = (0, _curry.default)((0, _compose.default)(_equals.default, toPath));

var useNavigation = function useNavigation(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep,
      onChange = _ref.onChange;

  var _ref2 = (0, _react.useState)((0, _history.createMemoryHistory)({
    initialEntries: steps,
    initialIndex: steps.findIndex(activeByPath(activeStep))
  })),
      _ref3 = _slicedToArray(_ref2, 1),
      history = _ref3[0];

  var _ref4 = (0, _react.useState)(pathToStep(history.location.pathname)),
      _ref5 = _slicedToArray(_ref4, 2),
      currentStep = _ref5[0],
      setCurrentStep = _ref5[1];

  (0, _react.useEffect)(function () {
    var unlisten = history.listen(function (_ref6) {
      var pathname = _ref6.location.pathname;
      var formattedStep = pathToStep(pathname);
      onChange(formattedStep);
      setCurrentStep(formattedStep);
    });
    history.replace(history.location.pathname);
    return function () {
      return unlisten();
    };
  }, []);

  var goTo = function goTo(pathname) {
    var targetIndex = steps.indexOf((0, _utils.addPrefix)('/', pathname));

    if (targetIndex !== -1) {
      history.go(targetIndex - history.index);
    }
  };

  var push = function push(pathname) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var targetRoute = (0, _utils.addPrefix)('/', pathname);
    history.push(targetRoute, state);
  };

  return {
    steps: steps,
    history: history,
    goTo: goTo,
    currentStep: currentStep,
    push: push,
    previous: history.back,
    next: history.forward
  };
};

exports.useNavigation = useNavigation;